'use client';

import { notFound, useRouter, useSearchParams } from 'next/navigation';
import { type FC, useEffect } from 'react';
import { useDialogs } from '@/components/dialogs/hooks';
import { removeQueryParameter } from '@/helpers/common';
import { QUERY_VIP } from '@/helpers/modals';
import { FAQByGroup } from '@/modules/restrictions/components/FAQByGroup';
import { useGetCommonStore } from '@/store';
import { BenefitsSection } from '../BenefitsSection';
import { ComparisonSection } from '../ComparisonSection';
import { IntroSection } from '../IntroSection';
import { StepsSection } from '../Steps';
import { ScVipPage } from './styled';

export const VipPageContent: FC = () => {
  const { modal } = useDialogs();
  const { push } = useRouter();
  const searchParams = useSearchParams();
  const useCommonStore = useGetCommonStore();

  const vip = useCommonStore.use.vip();
  const pendingUserPure = useCommonStore.use.pendingUserPure();

  useEffect(() => {
    if (!searchParams.get(QUERY_VIP) || modal || pendingUserPure) return;
    removeQueryParameter(QUERY_VIP, push);
  }, [push, pendingUserPure, modal, searchParams.get]);

  if (!vip) {
    notFound();
  }

  return (
    <ScVipPage>
      <IntroSection />
      <BenefitsSection />
      <StepsSection />
      <ComparisonSection />
      <FAQByGroup sections={vip.faq} withTitle />
    </ScVipPage>
  );
};
